<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { getToken } from './axios/getCookies'
import { verityToken } from './axios/user'
import queryString from 'query-string'


export default {
    data () {
        return {
            loginType: '',
            redirect_url: '',
        }
    },
    created() {
        // this.$cookies.remove('token')
        // const token = getToken()
        // this.getUrl(token)
        this.login()
        this.$store.dispatch('initJsEnc')
    },
    methods: {
        getUrl (token) {
            let newToken
            const urlObj = queryString.parseUrl(window.location.href)
            if (urlObj.query.redirect_url) {
                this.redirect_url = urlObj.query.redirect_url
                this.loginType = queryString.parseUrl(urlObj.query.redirect_url).query.type
            } else if (urlObj.query.type) {
                this.loginType = urlObj.query.type
            }
            if (token) {
                verityToken(token).then(({data}) => {
                    if (data.success) {
                        newToken = data.data
                        this.$cookies.set('token', newToken)
                        if (this.redirect_url === '') {
                            window.location.href = 'http://chain.genomics.cn/'
                        } else {
                            urlObj.url = urlObj.query.redirect_url
                            urlObj.query.ssoToken = newToken
                            delete urlObj.query.redirect_url
                            delete urlObj.query.type
                            window.location.href = queryString.stringifyUrl(urlObj)
                        }
                    } else {
                        this.login()
                    }
                }).catch()
            } else {
                this.login()
            }
        },

        login () {
            const urlObj = queryString.parseUrl(window.location.href)
            if (urlObj.query.redirect_url) {
                this.redirect_url = urlObj.query.redirect_url
                this.loginType = queryString.parseUrl(urlObj.query.redirect_url).query.type
            } else if (urlObj.query.type) {
                this.loginType = urlObj.query.type
            }
            if (this.redirect_url && this.loginType) {
                window.localStorage.setItem('redirect_loginType', this.loginType)
            } else if ( this.loginType ) {
                window.localStorage.setItem('redirect_loginType', this.loginType)
            }
        }
    }
}
</script>
<style lang="scss">
html, body {
    margin: 0;
    width: 100%;
    height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
